module.exports = __webpack_public_path__ + "img/res3.fa8f69f1.gif";